import React, { Component } from 'react'

export default class Wins extends Component {
    render() {
        return (
            <div className="container centerdiv">
            <h1 class="center-align">ATTRAKTIVE PREISE GEWINNEN</h1><br />
        
        <p>Schnell sein lohnt sich: Pro Bingo-Spiel gibt es xx Preise zu gewinnen.</p><br />
        <p>Preise für Teilnehmer, die im Stadion mitspielen.</p>
        <p>0 x eine Bratwurst vom Grill</p>
        <p>0 x Getränke-Gutschein</p>
        <p>0 x Gutschein für ein Sitzplatz-Ticket</p>
        <p>0 x Gutschein für ein Stehplatz-Ticket</p>
        <p>0 x Gutschein für ein Merchandise-Artikel XY</p><br />

        <p>Preise für Teilnehmer, die zu Hause mitspielen:</p>
        <p>0 x Gutschein für ein Sitzplatz-Ticket</p>
        <p>0 x Gutschein für ein Stehplatz-Ticket</p>
        <p>0 x Gutschein für ein Merchandise-Artikel XY</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Wins.jsx